<template>
  <div>
    <div class="page-header">
      <div class="page-header-index-wide">
        <!-- <a-breadcrumb class="breadcrumb">
          <a-breadcrumb-item>
            <router-link
              :to="{ path: '/' }"
            >首页</router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <span>小程序配置</span>
          </a-breadcrumb-item>
        </a-breadcrumb> -->
        <div class="detail">
          <div class="main" >
            <div class="row">
              <h1 class="title">小程序配置</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ak-setting :options="options" />
  </div>
</template>

<script>
export default {
  data () {
    return {
      options: [
        {
          title: '用户协议',
          inputs: [
            {
              name: 'userAgreement',
              note: '协议内容',
              type: 'Html',
              validators: [
                (val) => val ? null : '用户协议不可为空'
              ]
            }
          ]
        }, {
          title: '隐私政策',
          inputs: [
            {
              name: 'privacyPolicy',
              note: '政策内容',
              type: 'Html',
              validators: [
                (val) => val ? null : '隐私政策不可为空'
              ]
            }
          ]
        }, {
          title: '取消规则',
          inputs: [
            {
              name: 'cancelRule',
              note: '取消规则',
              type: 'Html',
              validators: [
                (val) => val ? null : '取消规则不可为空'
              ]
            }
          ]
        }, {
          title: '首页通告',
          inputs: [
            {
              name: 'circular',
              note: '首页通告',
              type: 'String',
              tooltip: '不填则不显示通告'
            }
          ]
        }, {
          title: '客服电话',
          inputs: [
            {
              name: 'contactPhone',
              note: '客服电话',
              type: 'String',
              validators: [
                (val) => val ? null : '客服电话不可为空'
              ]
            }
          ]
        }, {
          title: '发车提醒',
          inputs: [
            {
              name: 'reminder',
              note: '发车提醒',
              type: 'Number',
              tooltip: '用于小程序几小时前提醒乘客进行乘车，例：填写2则为发车前2小时向乘客发送提醒',
              validators: [
                (val) => {
                  if (val < 0) return '发车提醒不可为负数'
                  return null
                },
                value => {
                  let reg = /^(\d+)(.\d{0,1})?$/
                  return reg.test(value) ? null : '发车提醒最多为1位小数'
                }
              ]
            }
          ]
        }, {
          title: '腾讯地图Key',
          inputs: [
            {
              name: 'qqMapKey',
              note: '腾讯地图Key',
              type: 'String',
              tooltip: '小程序地点搜索、逆地址解析使用的腾讯位置服务Key，需开通WebServiceAPI并授权本小程序AppID；不填则使用小程序内置Key',
              validators: [
                (val) => {
                  if (!val) return null
                  return /^[A-Z0-9]{5}(-[A-Z0-9]{5}){5}$/.test(val.trim()) ? null : 'Key格式不正确'
                }
              ]
            }
          ]
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
  .page-header {
    background: #fff;
    padding: 16px 32px 0;
    border-bottom: 1px solid #e8e8e8;
    margin: -24px -24px 24px -24px;
    .breadcrumb {
      margin-bottom: 16px;
    }
    .detail {
      display: flex;
      /*margin-bottom: 16px;*/
      .avatar {
        flex: 0 1 72px;
        margin: 0 24px 8px 0;
        & > span {
          border-radius: 72px;
          display: block;
          width: 72px;
          height: 72px;
        }
      }
      .main {
        width: 100%;
        flex: 0 1 auto;
        .row {
          display: flex;
          width: 100%;
          .avatar {
            margin-bottom: 16px;
          }
        }
        .title {
          font-size: 20px;
          font-weight: 500;
          font-size: 20px;
          line-height: 28px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          margin-bottom: 16px;
          flex: auto;
        }
        .logo {
          width: 28px;
          height: 28px;
          border-radius: 4px;
          margin-right: 16px;
        }
        .content,
        .headerContent {
          flex: auto;
          color: rgba(0, 0, 0, 0.45);
          line-height: 22px;
          .link {
            margin-top: 16px;
            line-height: 24px;
            a {
              font-size: 14px;
              margin-right: 32px;
            }
          }
        }
        .extra {
          flex: 0 1 auto;
          margin-left: 88px;
          min-width: 242px;
          text-align: right;
        }
        .action {
          margin-left: 56px;
          min-width: 266px;
          flex: 0 1 auto;
          text-align: right;
          &:empty {
            display: none;
          }
        }
      }
    }
  }
  .mobile .page-header {
    .main {
      .row {
        flex-wrap: wrap;
        .avatar {
          flex: 0 1 25%;
          margin: 0 2% 8px 0;
        }
        .content,
        .headerContent {
          flex: 0 1 70%;
          .link {
            margin-top: 16px;
            line-height: 24px;
            a {
              font-size: 14px;
              margin-right: 10px;
            }
          }
        }
        .extra {
          flex: 1 1 auto;
          margin-left: 0;
          min-width: 0;
          text-align: right;
        }
        .action {
          margin-left: unset;
          min-width: 266px;
          flex: 0 1 auto;
          text-align: left;
          margin-bottom: 12px;
          &:empty {
            display: none;
          }
        }
      }
    }
  }
</style>
